import React, { ReactElement, ReactNode } from 'react';

import { logError } from '@gn-audio/jss-core';

interface ErrorBoundaryProps {
  children: ReactNode;
  name: string;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: unknown, errorInfo: unknown): void {
    logError(`Sitecore component "${this.props.name}" cannot be rendered`, error);
    console.error(errorInfo);
  }

  render(): ReactElement | null {
    const { hasError } = this.state;
    const { children, name } = this.props;
    const isDevelopment = !!process && process.env.NODE_ENV === 'development';

    if (hasError) {
      return isDevelopment ? (
        <div>
          <div>Cannot render {name} component</div>
          <h1>Something went wrong.</h1>
        </div>
      ) : null;
    }

    return <>{children}</>;
  }
}
